import { render, staticRenderFns } from "./formBlocksContainer.vue?vue&type=template&id=5db9a92c&scoped=true&"
import script from "./formBlocksContainer.vue?vue&type=script&lang=babel&"
export * from "./formBlocksContainer.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db9a92c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
